<template>
  <div class="d-flex justify-end flex-wrap mb-3 mt-1">
    <v-chip-group
      v-if="dueDate || showToday"
      :value="value"
      :disabled="disabled"
      @change="$emit('input', $event)"
      color="primary"
    >
      <v-chip v-if="dueDate" :value="dueDate" small label outlined class="ma-0">
        Vencimento
      </v-chip>
      <v-chip
        v-if="showToday"
        :value="today"
        small
        label
        outlined
        class="ma-0 ml-1"
      >
        Hoje
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "SettledDateChips",
  props: {
    value: {
      type: String,
      default: null,
    },
    dueDate: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    showToday() {
      if (!this.dueDate) return true;
      return this.today !== this.dueDate;
    },
  },
};
</script>
